import * as React from 'react';
import * as PropTypes from 'prop-types';
import Breadcrumbs from '../../containers/Breadcrumbs';
import config from 'config';
import { remotePaths } from 'router/routes';

const ChecksPage = ({ title, children }) => (
  <div className={'ChecksPage page'}>
    <Breadcrumbs />

    <div className="page-title boo">
      <div className={'row'}>
        <div className={'col-5 col-lg-9'}>
          <h1>{title}</h1>
        </div>

        {!config.isInspectorArm ? (
          <div className={'col-7 col-lg-3 right'}>
            <a className="button button__medium button__orange" href={remotePaths.checks}>
              Загрузить чек
            </a>
          </div>
        ) : null}
      </div>
    </div>

    <div className={'page-content'}>{children}</div>
  </div>
);

ChecksPage.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default ChecksPage;
